import { render, staticRenderFns } from "./TourPage.vue?vue&type=template&id=4b97bd48"
import script from "./TourPage.vue?vue&type=script&lang=js"
export * from "./TourPage.vue?vue&type=script&lang=js"
import style0 from "./TourPage.vue?vue&type=style&index=0&id=4b97bd48&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports